import React from 'react';
import { useQuery } from 'react-query';
import { Link } from 'react-router-dom';

import {
  Avatar,
  Box,
  Grid,
  List,
  ListItem,
  ListItemAvatar,
  ListItemSecondaryAction,
  ListItemText,
  Theme,
  Typography,
  makeStyles,
} from '@material-ui/core';
import { formatDistance } from 'date-fns';
import deLocale from 'date-fns/locale/es';

import { ReactComponent as RightIcon } from '../../../assets/img/icon/Right.svg';
import SubHeader from '../../../components/Header/SubHeader.component';
import Loader from '../../../components/LoaderSplash/Loader.component';
import {
  ASSISTANCE_NOTIFICATION,
  iconTypes,
} from '../../../constants/notifications.constant';
import {
  NOTIFICATIONS_QUERY,
  NOTIFICATIONS_QUERY_CONFIG,
  notificationsQuery,
} from '../../../query/notifications/notifications';

const useStyles = makeStyles((theme: Theme) => ({
  avatar: {
    width: theme.spacing(5),
    height: theme.spacing(5),
    backgroundColor: theme.palette.secondary.main,
  },
}));

const Notifications = () => {
  const { data: notifications, isLoading: loading } = useQuery(
    NOTIFICATIONS_QUERY,
    notificationsQuery,
    NOTIFICATIONS_QUERY_CONFIG
  );
  const classes = useStyles();

  return (
    <>
      <Box display={loading ? 'block' : 'none'}>
        <Loader action={'Cargando notificaciones'}></Loader>
      </Box>
      <SubHeader
        content={<Typography variant="h6">Notificaciones</Typography>}
      ></SubHeader>
      <Grid container justify="center" alignItems="center">
        <Grid item xs={11} sm={10} md={9} lg={8} xl={7}>
          <List>
            {notifications.map((notification: any) =>
              notification.notification_type === ASSISTANCE_NOTIFICATION ? (
                <ListItem
                  divider
                  key={notification.id}
                  component={Link}
                  to={'/assistance/' + notification.assistance_id}
                >
                  <ListItemAvatar>
                    <Avatar className={classes.avatar}>
                      <img
                        style={{ width: '60%' }}
                        src={
                          iconTypes[notification.notification_type] ||
                          iconTypes['general']
                        }
                        alt={'Notificacion'}
                      ></img>
                    </Avatar>
                  </ListItemAvatar>
                  <ListItemText
                    primary={
                      <Typography variant="subtitle1">
                        {notification.title}
                      </Typography>
                    }
                    secondary={
                      <>
                        <Typography
                          variant="subtitle2"
                          style={{ whiteSpace: 'break-spaces' }}
                        >
                          {notification.body}
                        </Typography>
                        <Typography variant="caption">
                          {formatDistance(
                            new Date(
                              new Date(notification.created_at).getFullYear(),
                              new Date(notification.created_at).getMonth(),
                              new Date(notification.created_at).getDate(),
                              new Date(notification.created_at).getHours(),
                              new Date(notification.created_at).getMinutes(),
                              new Date(notification.created_at).getSeconds()
                            ),
                            new Date(Date.now()),
                            {
                              addSuffix: true,
                              locale: deLocale,
                            }
                          )}
                        </Typography>
                      </>
                    }
                  />

                  <ListItemSecondaryAction>
                    <RightIcon></RightIcon>
                  </ListItemSecondaryAction>
                </ListItem>
              ) : (
                <ListItem divider key={notification.id}>
                  <ListItemAvatar>
                    <Avatar className={classes.avatar}>
                      <img
                        style={{ width: '60%' }}
                        src={
                          iconTypes[notification.notification_type] ||
                          iconTypes['general']
                        }
                        alt={'Notificacion'}
                      ></img>
                    </Avatar>
                  </ListItemAvatar>
                  <ListItemText
                    primary={
                      <Typography variant="subtitle1">
                        {notification.title}
                      </Typography>
                    }
                    secondary={
                      <>
                        <Typography
                          variant="subtitle2"
                          style={{ whiteSpace: 'break-spaces' }}
                        >
                          {notification.body}
                        </Typography>
                        <Typography variant="caption">
                          {formatDistance(
                            new Date(
                              new Date(notification.created_at).getFullYear(),
                              new Date(notification.created_at).getMonth(),
                              new Date(notification.created_at).getDate(),
                              new Date(notification.created_at).getHours(),
                              new Date(notification.created_at).getMinutes(),
                              new Date(notification.created_at).getSeconds()
                            ),
                            new Date(Date.now()),
                            {
                              addSuffix: true,
                              locale: deLocale,
                            }
                          )}
                        </Typography>
                      </>
                    }
                  />

                  <ListItemSecondaryAction>
                    <RightIcon></RightIcon>
                  </ListItemSecondaryAction>
                </ListItem>
              )
            )}
          </List>
        </Grid>
      </Grid>
    </>
  );
};

export default Notifications;
